import type scriptZh from '../zh/script';

const script: typeof scriptZh = {
  saved: 'Script saved',
  created: 'Script template created',
  col_updated: 'Updated',
  col_created: 'Created',
  actions: 'Actions',
  title: 'Scripts',
  detail_title: 'Script detail',
  detail_load_failed: 'Could not load script detail',
  detail_empty: 'No script detail',
  variables: 'Variables',
  load_failed: 'Could not load script templates',
  shop_required: 'Select a shop first',
  create_failed: 'Could not create the script template',
  update_failed: 'Could not save the script template',
  delete_failed: 'Could not delete the script template',
  delete_success: 'Script template deleted',
  delete_confirm: 'Delete script “{{name}}”? This cannot be undone.',
  new_template: 'New template',
  ds_generate: 'DS generate',
  generated_name: 'DS generate · {{point}}',
  generated: 'Generated. Confirm to save it as a template',
  channel_dm: 'DM',
  channel_email: 'Email',
  name_required: 'Enter a script name',
  content_required: 'Enter the script body',
  edit_title: 'Edit script',
  new_title: 'New script',
  name: 'Name',
  name_placeholder: 'e.g. New product sample · Beauty',
  channel: 'Channel',
  subject: 'Subject',
  subject_placeholder: 'Email subject, optional',
  body: 'Body',
  body_placeholder: 'Hi {{token}}, we have a new product your fans will love…',
  points_required: 'Enter a prompt',
  generate_failed: 'Generation failed. Please try again later',
  generate_title: 'Generate script',
  generate: 'Generate',
  name_hint: 'Name hint',
  name_hint_placeholder: 'e.g. New product sample · Beauty',
  selling_points: 'Prompt',
  points_placeholder: 'Beauty sample invitation, warm and short'
};

export default script;
